import { render } from "./template-email.vue?vue&type=template&id=6f607cd7&scoped=true"
import script from "./template-email.vue?vue&type=script&lang=js"
export * from "./template-email.vue?vue&type=script&lang=js"

import "./template-email.vue?vue&type=style&index=0&id=6f607cd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f607cd7"]])

export default __exports__